export const useUrlParams = () => {
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)

  // TODO: Add more url params
  return {
    hfpid: urlParams.get('hfpid'),
    refOrg: urlParams.get('org'),
    planID: urlParams.get('planID') || 'free',
    source: urlParams.get('source'),
    affiliate: urlParams.get('affiliate'),
  }
}
